export const CONTENT_SIZES = {
  WIDTH: 1248,
  CENTERED_MEDIUM_WIDTH: 824,
  CENTERED_SMALL_WIDTH: 600,
};